import * as types from "./actionTypes";

const initialState = {
  controls: [],
  checkedControls: []
};

const controls = (state = initialState, action) => {
  switch (action.type) {
    case types.CONTROLS_GET:
      return {
        ...state,
        controls: action.controls.response
      };

    case types.CONTROL_TOGGLE:
      const index = state.checkedControls.indexOf(action.control);
      if (index === -1) {
        return {
          ...state,
          checkedControls: [...state.checkedControls, action.control]
        };
      } else {
        return {
          ...state,
          checkedControls: state.checkedControls.filter(
            item => item !== action.control
          )
        };
      }

    case types.CONTROLS_FETCH_SUCCESS:
      return {
        ...state,
        controls: action.controls.response
      };

    default:
      return state;
  }
};

export default controls;



// WEBPACK FOOTER //
// ./src/modules/controls/reducer.js